import { app } from 'application';
import { useEffect, useState } from 'react';
import { AddCategoryModal, Button, PageContainer, SearchInput } from 'UI/elements';
import styles from './CategoriesManagementPage.module.scss';

import { observer } from 'mobx-react-lite';

function CategoriesManagementPage(): React.ReactElement {
  const categories = app().categoriesStore.categories;
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  useEffect(() => {
    const fetchCategories = async () => {
      await app().categoriesStore.fetchCategories();
    };
    fetchCategories();
  }, []);

  const maxChildrenCount = Math.max(...(categories?.map(cat => cat.children?.length || 0) || [0]));

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleSearch = (query: string) => {
    app().categoriesStore.searchCategories(query);
  };

  return (
    <PageContainer
      searchComponent={<SearchInput onSearch={handleSearch} placeholder="Find a category" />}
    >
      <div className={styles.wrapper}>
        <div className={styles.categoriesActions}>
          <Button onClick={handleOpenModal} theme="Primary">
            Add Category
          </Button>
        </div>

        <div className={styles.categoriesTableWrapper}>
          <table className={styles.categoriesTable}>
            <thead>
              <tr>
                {categories?.map(category => (
                  <th key={category.id} className={styles.headerCell}>
                    {category.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: maxChildrenCount }).map((_, rowIndex) => (
                <tr key={rowIndex}>
                  {categories?.map(category => (
                    <td key={category.id} className={styles.tableCell}>
                      {category.children?.[rowIndex] && (
                        <div className={styles.childItem}>{category.children[rowIndex].name}</div>
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <AddCategoryModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </PageContainer>
  );
}

const CategoriesManagementPageWithObserver = observer(CategoriesManagementPage);

export { CategoriesManagementPageWithObserver as CategoriesManagementPage };
